export const DIST_KEY = [
  {
    key: 'isScDistrict',
  },
  {
    key: 'isZcy',
  },
  {
    key: 'isWenlingGuotou',
  },
  {
    key: 'isNbDistrict',
  },
  {
    key: 'isJiaxingGongan',
  },
  {
    key: 'isZhoushanGongan',
  },
  {
    key: 'isShengZhouYiLiao',
  },
  {
    key: 'enableYWHT',
  },
  {
    key: 'isHzDistrict',
  },
  {
    key: 'operatorEnableAlias',
  },
  {
    key: 'isEnableGovBudget',
  },
  {
    key: 'isQuZhouYiLiao',
  },
  {
    key: 'isEnableFundSourceMatchPayChannel',
  },
  {
    key: 'isJinKong',
  },
  {
    key: 'approvalLumpEditable',
  },
];
